export const hongbao = {
    hb: "Kırmızı zarf",
    dps: "Büyük hediye dağıtımı",
    xdhb: "Sınırlı kırmızı zarflar, milyonlarca ödül sizi bekliyor",
    fxhb: "Kırmızı zarf paylaşarak daha fazla ödül kazanın",
    khb: "Kırmızı Zarfı Aç",
    kqz: "Açılıyor...",
    ylq: "Alındı",
    hdwks: "Etkinlik başlamadı",
    hdjxz: "Etkinlik devam ediyor",
    hdyjs: "Etkinlik sona erdi",
    hddjs: "Etkinlik geri sayımı",
    hdsj: "Etkinlik süresi",
    zwhd: "Şu anda etkinlik yok",
    hblsjlxq: "Kırmızı Zarf Ödül Geçmişim",
    jxz: "Devam Ediyor",
    ygq: "Süresi Doldu",
    dks: "Başlamak Üzere",
    zwjl: "Henüz ödül yok",
    wnmztj: "Etkinlik gereksinimlerini karşılamıyorsunuz",
    wxts: "Bilgilendirme",
    yhwcrz: "Kullanıcı KYC doğrulamasını ve cep telefonu numarası bağlamayı tamamladı",
    yhwcjy: "Kullanıcı şu işlemlerden birini tamamladı: spot işlem ≥100 USDT VEYA kontrat işlemi (kaldıraç hariç) ≥100 USDT VEYA opsiyon işlemi ≥100 USDT VEYA GameFi işlemi ≥100 USDT",
    djzh: "Risk kontrolü altındaki veya para çekme kısıtlamalı hesaplar etkinliğe katılamaz.",
    hdhbjl: "Ödül Alındı",
    sqbj: "Şanssızlık",
    dkapp: "Uygulamayı açın",
    smewm: "QR kodu tarayın",
    wchdtj: "Etkinlik şartlarını tamamlayarak kırmızı zarfı alın",
    fxhd: "Etkinliği paylaşarak daha fazla kırmızı zarf kazanın",
    jdcz: "Basit işlemlerle gelir elde edin",
    hdhb: "Etkinlik Kırmızı Zarfı",
    zdqj: "Belirtilen Dönem",
    wcjye: "{type} işlem hacmi {text} ≥ {amount} USDT tamamlayın",
    yhwfhtj: "Kırmızı zarfın başlatılmasından önceki {time} içinde, kullanıcının uygun işlemi yoktu",
    hbsxq: "Kırmızı zarfın başlatılmasından önceki {time}{day}içinde, kullanıcı {text}",
    bhgg: "Kaldıraç hariç",
    h: " veya ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/tr.js